import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastCtx = createContext(null);

const CORES = {
  sucesso: { bg: '#1D9E75', icon: '✓' },
  erro: { bg: '#B51013', icon: '✕' },
  aviso: { bg: '#EF9F27', icon: '!' },
  info: { bg: '#378ADD', icon: 'i' },
};

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const mostrar = useCallback((mensagem, tipo = 'sucesso', duracao = 3500) => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, mensagem, tipo }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), duracao);
  }, []);

  const fechar = (id) => setToasts(prev => prev.filter(t => t.id !== id));

  return (
    <ToastCtx.Provider value={{ mostrar }}>
      {children}
      <div style={{ position: 'fixed', bottom: '20px', right: '20px', display: 'flex', flexDirection: 'column', gap: '8px', zIndex: 9990, pointerEvents: 'none' }}>
        {toasts.map(t => {
          const config = CORES[t.tipo] || CORES.info;
          return (
            <div key={t.id} style={{
              display: 'flex', alignItems: 'center', gap: '10px',
              background: config.bg, color: '#fff',
              padding: '12px 16px', borderRadius: '10px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
              fontSize: '13px', fontWeight: '500',
              pointerEvents: 'all',
              animation: 'slideInRight 0.3s ease',
              maxWidth: '320px',
            }}>
              <span style={{ width: '20px', height: '20px', borderRadius: '50%', background: 'rgba(255,255,255,0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: '700', flexShrink: 0 }}>
                {config.icon}
              </span>
              <span style={{ flex: 1 }}>{t.mensagem}</span>
              <span onClick={() => fechar(t.id)} style={{ cursor: 'pointer', opacity: 0.7, fontSize: '14px', flexShrink: 0 }}>✕</span>
            </div>
          );
        })}
      </div>
      <style>{`
        @keyframes slideInRight {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </ToastCtx.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastCtx);
  if (!ctx) throw new Error('useToast deve ser usado dentro de ToastProvider');
  return ctx;
}
